import { createFileRoute } from '@tanstack/react-router';
import { DashboardInsights } from '@uturn/portal/modules/dashboard/insights';

export const Route = createFileRoute('/_protected/insights')({
	component: DashboardInsights,
});
